import * as React from "react";
const SvgMarchex = (props, ref) => (
  <svg
    version="1.1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    viewBox="0 0 174 206"
  >
    <path
      fill="#1C4081"
      opacity="1.000000"
      stroke="none"
      d="

M175.000000,82.000000
	C175.000000,123.972687 175.000000,165.445374 175.000000,206.959030
	C117.065514,206.959030 59.130985,206.959030 1.098230,206.959030
	C1.098230,138.444138 1.098230,69.888092 1.098230,1.166019
	C58.999619,1.166019 116.999763,1.166019 175.000000,1.166019
	C175.000000,27.868742 175.000000,54.684372 175.000000,82.000000
M51.275097,71.571205
	C50.853340,73.299568 50.075909,75.025482 50.063984,76.756668
	C49.920116,97.641479 49.859013,118.527138 49.907841,139.412277
	C49.910641,140.611053 51.050320,141.807159 52.261684,143.673599
	C56.276981,143.897903 60.292274,144.122223 64.963478,144.383179
	C64.963478,127.974319 64.963478,112.633438 64.963478,97.292557
	C65.339546,97.182541 65.715614,97.072533 66.091682,96.962517
	C73.159645,107.674362 80.227615,118.386200 87.799171,129.861252
	C95.409210,118.369995 102.398209,107.816521 109.387207,97.263046
	C110.679581,99.241768 110.870697,100.809395 110.874535,102.377472
	C110.903442,114.201553 110.890663,126.025734 110.901062,137.849869
	C110.906746,144.312134 110.915665,144.312469 117.533752,144.304733
	C118.366425,144.303757 119.203941,144.236710 120.030876,144.303513
	C122.792213,144.526581 123.845436,143.357376 123.835609,140.531784
	C123.758591,118.382622 123.810112,96.233009 123.736557,74.083817
	C123.732674,72.912285 123.305458,71.255249 122.476006,70.661606
	C119.600914,68.603889 111.688988,70.599388 109.651070,73.727097
	C103.379440,83.352524 97.163208,93.014030 90.903931,102.647537
	C90.048775,103.963684 89.071335,105.200378 87.789062,106.973732
	C86.286186,104.842155 85.201233,103.403168 84.220787,101.896179
	C78.772789,93.522316 73.377235,85.114227 67.910728,76.752518
	C63.062183,69.336044 60.766991,68.556358 51.275097,71.571205
M127.760872,42.649536
	C129.506622,43.927006 131.275360,45.174385 132.993973,46.487358
	C139.141083,51.183590 139.129501,51.189514 135.943817,57.787994
	C135.828354,58.027157 136.018875,58.414036 136.104645,58.983330
	C145.138702,58.983330 154.201736,58.983330 164.260788,58.983330
	C160.398300,49.969955 156.815247,41.608639 152.986847,32.674797
	C151.020264,34.773598 149.800735,36.075123 148.339340,37.634766
	C127.493446,19.649406 103.518585,11.931733 76.197891,14.737036
	C45.492085,17.889923 18.468891,40.310482 12.665946,54.926769
	C17.844723,54.926769 22.820532,55.226208 27.733128,54.798908
	C30.145260,54.589096 32.984413,53.612167 34.706608,51.997299
	C61.005421,27.337490 95.996437,23.573519 127.760872,42.649536
M21.578959,155.161865
	C18.509335,155.161865 15.439710,155.161865 11.226879,155.161865
	C15.360875,164.756592 18.975149,173.145081 22.774036,181.962051
	C24.701269,179.880035 25.916130,178.567596 27.373266,176.993423
	C48.218918,194.670883 71.954216,203.042068 99.127060,199.817703
	C126.403221,196.581100 147.691895,183.269272 164.561371,159.769180
	C159.532562,159.769180 155.911850,160.103714 152.377380,159.694092
	C146.448410,159.006943 142.247406,161.182861 137.849091,165.234283
	C112.091339,188.960510 71.116646,190.301422 43.505772,168.732330
	C37.040562,163.681808 37.041897,163.682327 39.955315,156.268387
	C40.001549,156.150726 39.867306,155.962128 39.609970,155.162186
	C34.074333,155.162186 28.314022,155.162186 21.578959,155.161865
M131.109024,139.541138
	C129.876266,139.541138 128.643509,139.541138 127.410751,139.541138
	C127.209824,140.035919 127.008896,140.530701 126.807968,141.025482
	C128.826019,142.023895 130.796555,143.159729 132.907440,143.889694
	C133.272629,144.015976 134.232498,142.422699 134.917694,141.623688
	C133.837021,140.984589 132.756332,140.345490 131.109024,139.541138
z"
    />
    <path
      fill="#B6BABD"
      opacity="1.000000"
      stroke="none"
      d="
M51.785530,71.050560
	C60.766991,68.556358 63.062183,69.336044 67.910728,76.752518
	C73.377235,85.114227 78.772789,93.522316 84.220787,101.896179
	C85.201233,103.403168 86.286186,104.842155 87.789062,106.973732
	C89.071335,105.200378 90.048775,103.963684 90.903931,102.647537
	C97.163208,93.014030 103.379440,83.352524 109.651070,73.727097
	C111.688988,70.599388 119.600914,68.603889 122.476006,70.661606
	C123.305458,71.255249 123.732674,72.912285 123.736557,74.083817
	C123.810112,96.233009 123.758591,118.382622 123.835609,140.531784
	C123.845436,143.357376 122.792213,144.526581 120.030876,144.303513
	C119.203941,144.236710 118.366425,144.303757 117.533752,144.304733
	C110.915665,144.312469 110.906746,144.312134 110.901062,137.849869
	C110.890663,126.025734 110.903442,114.201553 110.874535,102.377472
	C110.870697,100.809395 110.679581,99.241768 109.387207,97.263046
	C102.398209,107.816521 95.409210,118.369995 87.799171,129.861252
	C80.227615,118.386200 73.159645,107.674362 66.091682,96.962517
	C65.715614,97.072533 65.339546,97.182541 64.963478,97.292557
	C64.963478,112.633438 64.963478,127.974319 64.963478,144.383179
	C60.292274,144.122223 56.276981,143.897903 52.049858,142.877121
	C51.820530,118.403946 51.803028,94.727257 51.785530,71.050560
z"
    />
    <path
      fill="#B7BBBD"
      opacity="1.000000"
      stroke="none"
      d="
M127.453018,42.454659
	C95.996437,23.573519 61.005421,27.337490 34.706608,51.997299
	C32.984413,53.612167 30.145260,54.589096 27.733128,54.798908
	C22.820532,55.226208 17.844723,54.926769 12.665946,54.926769
	C18.468891,40.310482 45.492085,17.889923 76.197891,14.737036
	C103.518585,11.931733 127.493446,19.649406 148.339340,37.634766
	C149.800735,36.075123 151.020264,34.773598 152.986847,32.674797
	C156.815247,41.608639 160.398300,49.969955 164.260788,58.983330
	C154.201736,58.983330 145.138702,58.983330 136.104645,58.983330
	C136.018875,58.414036 135.828354,58.027157 135.943817,57.787994
	C139.129501,51.189514 139.141083,51.183590 132.993973,46.487358
	C131.275360,45.174385 129.506622,43.927006 127.453018,42.454659
z"
    />
    <path
      fill="#B8BBBD"
      opacity="1.000000"
      stroke="none"
      d="
M22.066334,155.162018
	C28.314022,155.162186 34.074333,155.162186 39.609970,155.162186
	C39.867306,155.962128 40.001549,156.150726 39.955315,156.268387
	C37.041897,163.682327 37.040562,163.681808 43.505772,168.732330
	C71.116646,190.301422 112.091339,188.960510 137.849091,165.234283
	C142.247406,161.182861 146.448410,159.006943 152.377380,159.694092
	C155.911850,160.103714 159.532562,159.769180 164.561371,159.769180
	C147.691895,183.269272 126.403221,196.581100 99.127060,199.817703
	C71.954216,203.042068 48.218918,194.670883 27.373266,176.993423
	C25.916130,178.567596 24.701269,179.880035 22.774036,181.962051
	C18.975149,173.145081 15.360875,164.756592 11.226879,155.161865
	C15.439710,155.161865 18.509335,155.161865 22.066334,155.162018
z"
    />
    <path
      fill="#1F4072"
      opacity="1.000000"
      stroke="none"
      d="
M51.530312,71.310883
	C51.803028,94.727257 51.820530,118.403946 51.749462,142.542572
	C51.050320,141.807159 49.910641,140.611053 49.907841,139.412277
	C49.859013,118.527138 49.920116,97.641479 50.063984,76.756668
	C50.075909,75.025482 50.853340,73.299568 51.530312,71.310883
z"
    />
    <path
      fill="#5E7DAA"
      opacity="1.000000"
      stroke="none"
      d="
M131.392334,139.623764
	C132.756332,140.345490 133.837021,140.984589 134.917694,141.623688
	C134.232498,142.422699 133.272629,144.015976 132.907440,143.889694
	C130.796555,143.159729 128.826019,142.023895 126.807968,141.025482
	C127.008896,140.530701 127.209824,140.035919 127.410751,139.541138
	C128.643509,139.541138 129.876266,139.541138 131.392334,139.623764
z"
    />
  </svg>
);

export default React.forwardRef(SvgMarchex);
